import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { AppComponentContext } from '../../../../global/cnr/contexts/AppComponentContext';
import { AppFormsContext } from '../../../../global/cnr/contexts/AppFormsContext';
import { AppUserContext } from '../../../../global/cnr/contexts/AppUserContext';
import { ComponentsContext } from '../../../../global/cnr/contexts/ComponentsContext';
import { DataWrapperContext } from '../../../../global/cnr/contexts/DataWrapperContext';
import { FrameworkContext } from '../../../../global/cnr/contexts/FrameworkContent';
import { HeaderContext } from '../../../../global/cnr/contexts/HeaderContext';
import { PageAreaContext } from '../../../../global/cnr/contexts/PageAreaContext';
import { PapsContext } from '../../../../global/cnr/contexts/PapsContext';
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { separateContexts } from '../../../../global/common/filtering';
import { GolfTournamentContext } from './GolfTournamentContext';
import { PageDimmerContext } from '../../../../global/cnr/contexts/PageDimmerContext';
import { NavigationContext } from '../../../../global/cnr/contexts/NavigationContext';
import { createRefPath_client, createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import { EventInfoContext } from 'global/cnr/contexts/EventInfoContext';
import { fsfn_allGolf } from 'projectSpecific/golf/functions/fbGolf';
import { fsCallAll } from 'global/cnr/contexts/contextHelpers/fcCalls';
import { AppContext } from 'global/cnr/contexts/AppProvider';

export const GolfParentContext = createContext();

/**
 * 
 * @param {object} props 
 * @returns GolfParentContext with golfParent_contexts
 */
const GolfParentProvider = (props) => {

  const appFormsContext = useContext(AppFormsContext);
  const appUserContext = useContext(AppUserContext);
  const dataWrapperContext = useContext(DataWrapperContext)
  const frameworkContext = useContext(FrameworkContext);
  const golfEventContext = useContext(AppComponentContext)
  const golfTournamentContext = useContext(GolfTournamentContext)
  const headerContext = useContext(HeaderContext);
  const navigationContext = useContext(NavigationContext)
  const pageAreaContext = useContext(PageAreaContext)
  const pageDimmerContext = useContext(PageDimmerContext)
  const papsContext = useContext(PapsContext)
  const parentContext = useContext(ParentContext);
  const eventInfoContext = useContext(EventInfoContext);
  const componentsContext = useContext(ComponentsContext);

  const { components_state } = componentsContext ?? {}
  const { componentFilters } = components_state ?? {}
  const { eventInfo_handlers } = eventInfoContext ?? {}

  const { fns, states } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { database_fns } = fns ?? {}

  const appContext = useContext(AppContext);
  const { app_state } = appContext
  const { mainFunctions } = app_state

  const [golfParent_state, setGolfParentState] = useState({})
  // 
  const fsCall = async (genericType, callData) => {
    return fsCallAll(mainFunctions, genericType, callData)
  }

  const { golfParent_contexts, componentContexts } = useMemo(() => {
    const contexts = {
      appFormsContext,
      appUserContext,
      dataWrapperContext,
      frameworkContext,
      golfEventContext,
      golfTournamentContext,
      headerContext,
      navigationContext,
      pageAreaContext,
      papsContext,
      parentContext,
      pageDimmerContext,
    }
    componentFilters.state.push('appUser_state')
    componentFilters.functions.push('navigation_fns')
    const c = separateContexts(contexts, componentFilters, true, true)
    return { golfParent_contexts: c, componentContexts: contexts }
  }, [golfTournamentContext, golfEventContext])

  useEffect(() => {
    const refPath1 = createRefPath_client(pathViews, ['_golfCourses', 'golfCourses'])
    const refPath2 = createRefPath_event(pathViews, ['teams'])
    const cb1 = (res) => {
      setGolfParentState({ golfCourses: res?.golfCourses?.golfCourses })
      eventInfo_handlers.handleSet_eventStaticView('golfCourses', res?.golfCourses?.golfCourses)
    }
    const cb2 = (res) => {
      setGolfParentState({ teams: res })
      eventInfo_handlers.handleSet_eventStaticView('teams', res)
    }
    database_fns.get_data({ refPath: refPath1, callback: cb1 })
    database_fns.get_data({ refPath: refPath2, callback: cb2 })
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  const functions_fns = useMemo(
    () => ({
      fc_golf: fsfn_allGolf(fsCall),
    }),
    []
  );

  const functions_cls = useMemo(() => {
    const merged = {};
    _.forEach(functions_fns, (fnp) => {
      _.forEach(fnp, (fnpi, fnpik) => {
        if (merged[fnpik]) {
          console.log("DUP", fnpik);
        } else {
          merged[fnpik] = fnpi;
        }
      });
    });
    return merged;
  }, [functions_fns]);

  return golfParent_contexts ?
    <GolfParentContext.Provider value={{ golfParent_contexts, golfParent_state, golfParent_cls: functions_cls, componentContexts }} >
      {props.children}
    </GolfParentContext.Provider>
    :
    <div></div>
}


export default GolfParentProvider